// extracted by mini-css-extract-plugin
export default {"searchWidgetPreview":"headerSearchWidgetPreview-module__searchWidgetPreview__Idjrp","widgetWrapper":"headerSearchWidgetPreview-module__widgetWrapper__eN55q"};